<template>
	<div id="index">
		<Header :current="0"></Header>
		<!-- banner -->
		<div class="banner">
			<div
				class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container mx-auto py-6 box-border flex   justify-between">
				<div class="w-[385px] h-[355px]  box-border rounded-l px-[21px] py-[31px] bg-[#3A364D]  ">
					<div @click="classClick(item,index)"
						class="cursor-pointer text-white text-base mb-4 courseClassItem"
						v-for="(item,index) in courseClassList" :key="index">
						{{item.name}}
					</div>
				</div>
				<el-carousel height="355px" style="width: calc(100% - 385px);" arrow="always" :autoplay="false">
					<el-carousel-item v-for="(item,index) in bannerList" :key="index">
						<el-image class="w-full h-full" :src="item.image" fit="cover"></el-image>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- banner -->

		<div class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container mx-auto">
			<!-- 全部课程 -->

			<div class="flex   items-center justify-between mb-[18px]">
				<div class="flex   items-end">
					<img src="@/static/image/icon45.png" class="w-[58px] h-[35px] mr-[7px]" alt="" />
					<label class="text-[28px] font-bold mr-3">{{langInfo.index_all_courses}}</label>
					<label class="text-base text-[#1C1F21]">{{langInfo.index_courses_tip}}</label>
				</div>
				<router-link class="no-underline " :to="{path:'/courseCenter'}">
					<label class="text-[#1C1F21]  mr-1.5 text-[16px] cursor-pointer">{{langInfo.more_courses}}</label>
					<i class="el-icon-arrow-right text-black text-[16px] cursor-pointer"></i>
				</router-link>
			</div>
			<div class="mb-[20px]">
				<div class="2xl:columns-4 xl:max-w-7xl grid grid-cols-4 gap-[27px]" ref="courseList">
					<div @click="goCourseDetail(item,index)" class="mb-[30px] courseInfo cursor-pointer inline-block"
						v-for="(item,index) in courseList" :key="index">
						<div class="rounded-md">
							<div class="w-full  relative" :style="{height:height+'px'}">
								<el-image class="w-full h-full" :src="item.cover_img" fit="cover"></el-image>
								<!-- <div class="absolute w-full h-full z-1 top-0 left-0 px-2 pt-[33px] box-border">
									<div class="w-[20px] h-[3px] bg-white mb-[8px]">

									</div>
									<div class="text-white font-bold text-lg mb-[8px]">
										HKSI Paper 12
									</div>
									<div class="text-white text-sm font-bold text-lg">
										香港证券卷十二
									</div>
								</div> -->
							</div>
							<div class="px-2.5 box-border shadow-01">
								<div
									class="h-[80px] bB-02  pt-[4px] pb-[10px] box-border flex flex-col justify-between ">
									<div class="text-[#1C1F21] yw-text-cut-2 text-[14px]">
										<label v-if="item.is_selected==1"
											class="bg-[#E25B5B] inline-block text-white text-xs px-[6px] box-border min-w-[38px] h-[16px] text-center leading-[16px]">{{langInfo.Premium}}</label>
										{{item.name}}
										<!-- <label
											class="hotSign relative rounded-[4px] inline-block w-[32px] h-[15px] leading-[15px] text-white text-center text-white font-bold text-[10px]">Hot</label>
									 -->
									</div>
									<div class="text-[#1C1F21]">
										¥{{item.course_discount}}
									</div>
								</div>
								<div class="pt-[10px] pb-[14px] flex   items-center justify-between">
									<div class="flex   ">
										<img class="w-[16px] h-[16px] mr-[6px]" src="@/static/image/icon03.png" alt=""
											srcset="" />
										<label class="text-xs text-[#9199A1]">{{item.sales_volume}}
											{{langInfo.person_purchased}}</label>
									</div>
									<label class="text-xs text-[#9199A1]">{{item.study_count}}
										{{langInfo.people_learned}}</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 全部课程 -->
			<!-- 资讯中心 -->
			<div class="flex   items-center justify-between mb-[18px]">
				<div class="flex   items-end">
					<img src="@/static/image/icon47.png" class="w-[55px] h-[27px] mr-[7px]" alt="" />
					<label class="text-[28px]  font-bold mr-3">{{langInfo.head_news_nav}}</label>
					<label class="text-base text-[#1C1F21]">{{langInfo.news_tip}}</label>
				</div>
				<router-link class="cursor-pointer no-underline flex items-center" :to="{path:'/newsCenter'}">
					<div class="text-[#1C1F21]  mr-1.5 text-[16px]">{{langInfo.more_info}}</div>
					<i class="el-icon-arrow-right text-black text-[16px]"></i>
				</router-link>
			</div>
			<div class="2xl:columns-3 xl:max-w-7xl grid grid-cols-3 gap-[48px]" ref="newsList">

				<router-link :to="{path:'/newsDetail',query: { id: item.id }}"
					class="mb-[30px] no-underline px-[20px] pt-5 pb-3 box-border inline-block newsItem"
					v-for="(item,index) in newsList" :key="index">
					<div class="pb-3 box-border bB-01">
						<el-image class="w-full mb-[17px]" :style="{height:newsHeight+'px'}" :src="item.image" fit="cover"></el-image>
						<p class="text-[16px] text-[#5B73FD]  mb-2.5 yw-text-cut-1" style="">
							{{item.title}}
						</p>
						<div class="text-sm text-[#3A364D] yw-text-cut-1">
							{{item.subtitle}}
						</div>
					</div>
					<div class="text-[#9199A1] pt-9 box-border flex   items-center justify-between">
						<label>{{item.create_time}}</label>
						<div class="flex   items-center">
							<img src="@/static/image/icon04.png" class="w-[22px] h-[22px] mr-2" alt="" />
							<label class="mr-[15px]">{{item.number_views}}</label>
							<img src="@/static/image/icon05.png" class="w-[22px] h-[22px] mr-2" alt="" />
							<label>{{item.number_likes}}</label>
						</div>
					</div>
				</router-link>
			</div>
			<!-- 资讯中心 -->
		</div>
		<!-- 资源下载 -->
		<div class="bg-[#F5F7FA] pt-[34px] pb-[83px] box-border">
			<div
				class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container mx-auto  flex   items-center justify-between mb-[25px]">
				<div class="flex items-end  titleSign relative pl-[16px] box-border">
					<label class="text-[28px] font-bold mr-3">{{langInfo.head_download_nav}}</label>
					<label class="text-base text-[#1C1F21]">{{langInfo.resources_tip}}</label>
				</div>
				<router-link class="cursor-pointer no-underline flex items-center" :to="{path:'/resourceDownload'}">
					<div class="text-[#1C1F21]    mr-1.5 text-[16px]">{{langInfo.more_content}}</div>
					<i class="el-icon-arrow-right  text-black text-[16px]"></i>
				</router-link>
			</div>
			<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto   grid grid-cols-2 gap-[16px]">
				<router-link :to="{path:'/resourceDetail',query: { id: item.id }}"
					class="cursor-pointer no-underline bg-white flex justify-between newsItem py-5 px-3.5 box-border "
					v-for="(item,index) in resource_download_list" :key="index">

					<el-image class="w-[198px] h-[131px]" :src="item.image" fit="cover"></el-image>
					<div class="h-[131px] pt-[4px] box-border" style="width: calc(100% - 218px);">
						<div class="bB-01 pb-[12px] box-border">
							<p class="text-[16px] text-[#5B73FD]  mb-2.5 yw-text-cut-1" style="">
								{{item.title}}
							</p>
							<div class="text-sm text-[#3A364D] yw-text-cut-1">
								{{item.subtitle}}
							</div>
						</div>
						<div class="text-[#9199A1]  pt-9 box-border flex   items-center justify-between">
							<label>{{item.create_time}}</label>
							<div class="flex   items-center">
								<img src="@/static/image/icon04.png" class="w-[22px] h-[22px] mr-2" alt="" />
								<label class="mr-[15px]">{{item.number_views}}</label>
								<img src="@/static/image/icon05.png" class="w-[22px] h-[22px] mr-2" alt="" />
								<label>{{item.number_likes}}</label>
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<!-- 资源下载 -->
		<!-- 问答专区 -->
		<div class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container mx-auto pt-[36px] pb-[64px] box-border">
			<div class="  flex   items-center justify-between mb-[25px]">
				<div class="flex items-end titleSign relative  pl-[16px] box-border">
					<label class="text-[28px] font-bold mr-3">{{langInfo.QA_Zone}}</label>
					<label class="text-base text-[#1C1F21]">{{langInfo.QA_Zone_tip}}</label>
				</div>
				<router-link class="cursor-pointer no-underline flex items-center" :to="{path:'/QAZone'}">
					<div class="text-[#1C1F21]  mr-1.5 text-[16px]">{{langInfo.more_QA}}</div>
					<i class="el-icon-arrow-right text-black text-[16px]"></i>
				</router-link>
			</div>
			<div class="2xl:max-w-7xl xl:max-w-7xl grid grid-cols-2 gap-[16px]">
				<router-link :to="{path:'/QAZoneDetail',query: { id: item.id }}" v-for="(item,index) in communityList"
					:key="index"
					class="bg-[#F7F9FC] no-underline flex flex-col justify-between h-[225px] rounded-[5px] pt-[18px]  pb-[16px] pl-[10px] pr-[20px] box-border">
					<div class="">
						<div class="flex justify-between mb-7 ">
							<img class="w-[24px] h-[24px] mr-[9px]" src="@/static/image/icon07.png" alt="" srcset="" />
							<div class="text-[16px] text-[#000000] yw-text-cut-1" style="width: calc(100% - 34px);">
								{{item.title}}
							</div>
						</div>
						<div class="flex justify-between  ">
							<img class="w-[24px] h-[24px] mr-[9px]" src="@/static/image/icon08.png" alt="" srcset="" />
							<div class="text-[16px] text-[#000000]" style="width: calc(100% - 34px);">
								{{item.subtitle}}
							</div>
						</div>
					</div>
					<div class="text-[#9199A1]  text-right">{{item.create_time}}</div>
				</router-link>
			</div>
		</div>
		<!-- 问答专区 -->
		<Footer></Footer>


		<el-dialog @close="closeDialog" :visible.sync="noticeShow" :close-on-click-modal="false" width="40%" center
			top="8vh">
			<div>
				<div class="text-[#000000] text-[26px] mb-[18px] font-bold text-center">
					{{noticeInfo.title}}
				</div>
				<div v-html="noticeInfo.textarea"></div>
			</div>
		</el-dialog>


		<el-dialog :title="langInfo['reg_tip']" :visible.sync="translateTip" width="30%" center :show-close="false">
			<div class="mb-[14px] text-[15px]">{{langInfo['translate_tip']}}</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="knowClick()">{{langInfo['read_understood']}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { EventBus } from '../../js/event-bus.js';
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				bannerList: [],
				courseClassList: [],
				// 课程列表
				courseList: [],
				searchValue: '',
				langInfo: {},
				newsList: [], //资讯列表 
				resource_download_list: [], //资源下载列表
				communityList: [], //问答专区列表

				width: 0,
				height: 0,
				
				newsHeight:0,
				userInfo: {},

				noticeShow: false,
				noticeInfo: {
					title: '',
					textarea: '',
				},

				translateTip: false
			}
		},
		mounted() {
			this.getUserInfo()

			this.get_category_list() //首页的分类
			this.get_product_list() //首页产品

			// 资讯列表
			this.get_news_news_list()

			// 资源下载列表
			this.get_resource_download_list()
			// 问答专区列表
			this.get_community_list()
			// banner
			this.get_bannerList()

			this.getdict_data()

			this.getconfig()
		},
		methods: {
			judgment() {
				if (!localStorage.getItem('translateTip')) {
					setTimeout(() => {
						this.translateTip = true
					}, 1000)
				}
			},
			knowClick() {
				this.translateTip = false
				localStorage.setItem('translateTip', true)
			},




			getconfig() {
				this.$api.config({}).then((res) => {
					document.title = res.data.Introduction
					let metaDescription = document.querySelector('meta[name="description"]');
					if (metaDescription) {
						metaDescription.setAttribute('content', res.data.Introduction);
					} else {
						metaDescription = document.createElement('meta');
						metaDescription.setAttribute('name', 'description');
						metaDescription.setAttribute('content', res.data.Introduction);
						document.head.appendChild(metaDescription);
					}

				}).catch((error) => {
					if (error.code == 450) {
						localStorage.removeItem('userInfo')
						localStorage.removeItem('token')
					}
				})
			},
			closeDialog() {
				this.noticeShow = false
				this.noticeInfo.title = ''
				this.noticeInfo.textarea = ''

			},
			getUserInfo() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data
					this.getSystemNotice()
				}).catch((error) => {

				})
			},
			getSystemNotice() {
				this.$api.getSystemNotice().then((res) => {
					console.log("通知信息");
					console.log(res);
					if (res.data) {
						this.noticeInfo = res.data
						this.noticeShow = true
					}
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			get_bannerList() {
				this.$api.bannerList({ mark: 'homepage' }).then((res) => {
					this.bannerList = res.data.list_class
				}).catch((error) => {})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.judgment()


					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			get_category_list() {
				this.$api.category_list({}).then((res) => {
					console.log(res);
					this.courseClassList = res.data
				}).catch((error) => {

				})
			},
			classClick(item, index) {
				this.$router.push({
					path: '/courseCenter',
					query: {
						course_category_id: item.id
					}
				})
			},
			get_product_list() {
				this.$api.product_list({
					is_selected: 1,
					page: 1,
					limit: 8
				}).then((res) => {
					console.log("商品=====");
					console.log(res);
					this.courseList = res.data.data

					this.width = this.$common.calculateWidthHeight(this.$refs.courseList.offsetWidth, 3, 2, 81, 4).width
					this.height = this.$common.calculateWidthHeight(this.$refs.courseList.offsetWidth, 3, 2, 81, 4).height

				}).catch((error) => {

				})
			},
			goCourseDetail(item, index) {
				console.log(item);
				this.$router.push({
					path: 'courseDetail',
					query: {
						id: item.id
					}
				}); // 使用完整路径
			},
			get_news_news_list() {

				// 资讯列表
				this.$api.news_news_list({

					page: 1,
					limit: 3
				}).then((res) => {

					this.newsList = res.data.list
					
					this.newsHeight = this.$common.calculateWidthHeight(this.$refs.newsList.offsetWidth, 2.35, 1, 216, 3).height
					
				}).catch((error) => {

				})
			},
			// 资源下载列表
			get_resource_download_list() {
				// 资讯列表
				this.$api.resource_download_list({
					page: 1,
					limit: 2
				}).then((res) => {
					console.log("资源下载列表=====");
					console.log(res);
					this.resource_download_list = res.data.list
				}).catch((error) => {

				})
			},
			// 问答专区列表
			get_community_list() {
				this.$api.community_list({
					page: 1,
					limit: 2
				}).then((res) => {
					console.log("问答专区列表=====");
					console.log(res);
					this.communityList = res.data.list
				}).catch((error) => {

				})
			}

		}
	}
</script>

<style scoped>
	.banner {
		height: 407px;
		background: linear-gradient(180deg, rgba(110, 175, 247, 1) 0%, rgba(112, 176, 247, 0.64) 0%, rgba(120, 179, 248, 0.11) 34%, rgba(255, 255, 255, 0.11) 100%);
	}

	.courseClassItem:nth-last-child(1) {
		margin-bottom: 0;
	}


	.newsItem {
		box-shadow: 0px 2px 6px 0px rgba(95, 101, 105, 0.4);
	}

	.hotSign {
		background: linear-gradient(227.78deg, rgba(226, 91, 91, 1) 17.74%, rgba(232, 123, 123, 1) 92.88%);
	}

	.hotSign::after {
		content: '';
		position: absolute;

		width: 0;
		height: 0;
		border-top: 5px solid transparent;
		border-right: 5px solid #DD5C5C;
		border-bottom: 5px solid transparent;
		top: -4px;
		right: 0;
	}

	.titleSign::after {
		content: '';
		position: absolute;
		width: 6px;
		height: 30px;
		left: 0;
		border-radius: 2px;
		background-color: rgba(91, 115, 253, 1);
	}
</style>